import * as XLSX from 'xlsx'
import { exportHeader } from './toCSV'

/**
 * Puur: zet een lijst objecten om naar het raster (rijen van cellen) van een
 * Excel-blad, met dezelfde kolomvolgorde als de CSV-export.
 *
 * Nodig naast toCSV omdat een CSV in een Nederlandse Excel in één kolom landt
 * (die verwacht puntkomma's) en een antwoord met een Enter erin daar over
 * meerdere rijen uiteenvalt. In een echt Excel-bestand is elke cel een cel.
 * Updateverzoek Meppel Actief, 2026-10-15.
 *
 * @param {Array<Record<string, any>>} rows - De rijen; sleutels worden kolommen
 * @param {string[]} [headerOrder] - Gewenste kolomvolgorde; ontbrekende kolommen komen erachter
 * @returns {Array<Array<any>>} Kopregel plus één regel per rij, of een lege lijst zonder rijen
 */
export const toSheetRows = (rows, headerOrder) => {
    if (!rows || rows.length === 0) return []

    const header = exportHeader(rows, headerOrder)

    const cell = (value) => {
        if (value === undefined || value === null) return ''
        // Zelfde afspraak als de CSV: een lijst leesbaar in één cel.
        if (Array.isArray(value)) return value.join(', ')
        return value
    }

    return [header, ...rows.map((row) => header.map((key) => cell((row || {})[key])))]
}

/**
 * Zet rijen om naar een Excel-bestand (.xlsx) en start de download.
 *
 * @param {Array<Record<string, any>>} rows - De rijen om te exporteren
 * @param {string} filename - Bestandsnaam inclusief .xlsx
 * @param {string[]} [headerOrder] - Gewenste kolomvolgorde
 * @returns {boolean} false wanneer er niets te exporteren viel
 */
const downloadXLSX = (rows, filename, headerOrder) => {
    const grid = toSheetRows(rows, headerOrder)
    if (grid.length === 0) return false

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(grid), 'Data')
    XLSX.writeFile(workbook, filename)

    return true
}

export default downloadXLSX
